import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid2 as Grid,
  Link,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { forgotPasswordReq } from "../../redux/member-slices/auth.slice";
import { forgotPasswordSchema } from "../../utils/velidations";
import InputFieldB from "../../components/ui/InputFieldB";
import { useDispatch, useSelector } from "react-redux";
import { Link as NavLink } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { useState } from "react";

function ForgotPassword() {
  const dispatch = useDispatch();
  const [helperText, setHelperText] = useState([]);
  const { other } = useSelector((state) => state.memberSlice);

  // Handle forgot password
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    const formData = Object.fromEntries(form);
    const result = forgotPasswordSchema.safeParse(formData);
    if (!result.success) {
      const groupedErrors = {};
      result.error.issues.forEach((issue) => {
        const key = issue.path[0];
        if (!groupedErrors[key]) {
          groupedErrors[key] = [];
        }
        groupedErrors[key].push(issue.message);
      });
      setHelperText(groupedErrors);
      return;
    }
    setHelperText([]);
    dispatch(forgotPasswordReq(formData))
      .unwrap()
      .catch(() => {})
      .finally(() => {
        e.target.reset();
      });
  };

  return (
    <Box sx={{ py: 3 }}>
      <Container maxWidth={false} fixed>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 6 }} mx="auto">
            <Paper
              sx={{
                p: 3,
                border: "1px solid #f0f0f0",
              }}
              component="form"
              onSubmit={handleSubmit}
            >
              <Typography
                mb={1}
                fontSize={20}
                component="h4"
                color="other.color1"
                fontWeight="600"
                textAlign="center"
              >
                Forgot Password
              </Typography>
              <Typography mb={3} color="other.color1" textAlign="center">
                No worries! Enter your email below, and we’ll send you a link to
                reset your password.
              </Typography>

              <Stack spacing={3}>
                <InputFieldB
                  type="email"
                  name="email"
                  label="Email"
                  inputtype="InputFieldB"
                  helperText={helperText}
                  placeholder="Enter email"
                />
                <Box>
                  <ReCAPTCHA sitekey={process.env.REACT_APP_CAPTCHA_KEY} />
                  {helperText?.["g-recaptcha-response"] && (
                    <Typography mt={0.5} fontSize="14px" color="error.main">
                      {helperText?.["g-recaptcha-response"]}
                    </Typography>
                  )}
                  <Typography
                    fontSize={14}
                    color="other.color1"
                    textAlign="end"
                  >
                    <Link
                      to="/login"
                      sx={{ mb: "20px" }}
                      underline="hover"
                      component={NavLink}
                    >
                      Login now
                    </Link>
                  </Typography>
                </Box>
                <Button
                  sx={{
                    fontSize: "18px",
                    justifyContent: "center",
                  }}
                  type="submit"
                  variant="contained"
                  endIcon={
                    other?.loadingLogin && (
                      <CircularProgress size={22} color="text" thickness={6} />
                    )
                  }
                >
                  Submit
                </Button>
              </Stack>
              <Typography
                mt={1}
                color="other.color1"
                variant="body2"
                textAlign="center"
                fontStyle="italic"
              >
                Didn't receive the email? Check your spam folder or &nbsp;
                <Link
                  sx={{ whiteSpace: "nowrap" }}
                  to="/help-center"
                  underline="hover"
                  component={NavLink}
                >
                  contact support
                </Link>
                .
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default ForgotPassword;
